import {
  ListItem,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  UnorderedList,
  useDisclosure,
} from '@chakra-ui/react';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import { Button } from '@web-app/components/ui/Button/button';
import React, { useEffect, useRef } from 'react';

const MbiotaReminderModal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialFocusRef = useRef<HTMLElement>(null);

  useEffect(() => {
    onOpen();
  }, [onOpen]);

  return (
    <SessionReminderModal
      popupId="mbiota-patient-reminders"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      initialFocusRef={initialFocusRef}
    >
      <ModalOverlay />
      <ModalContent
        ref={initialFocusRef as React.Ref<HTMLElement>}
        tabIndex={-1}
        sx={{ outline: 'none' }}
        bg="bg.default"
        color="text.default"
      >
        <ModalHeader>mBIOTA Patient Reminders</ModalHeader>

        <ModalBody>
          <UnorderedList spacing={3} pl={2}>
            <ListItem>
              <strong>What is mBIOTA?</strong> An advanced gut health and
              microbiome platform designed to provide personalized insights and
              therapeutic nutritional interventions for digestive wellness.
            </ListItem>
            <ListItem>
              Recommend dietary strategies and protocols that support your
              patient&apos;s gut microbiome goals, and use mBIOTA&apos;s program
              resources as a reference during your sessions.
            </ListItem>
            <ListItem>
              Partnerships are vital to the Berry Street ecosystem — revisit
              mBIOTA orientation{' '}
              <a
                href="https://community.berrystreet.co/c/mayo-clinic/new-partnership-welcome-mbiota"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-legacy underline"
              >
                here
              </a>
              .
            </ListItem>
          </UnorderedList>
        </ModalBody>

        <ModalFooter>
          <div className="flex w-full flex-col gap-2">
            <Button
              onClick={onClose}
              className="w-full bg-primary-legacy text-primary-foreground hover:bg-primary-legacy/90"
            >
              Got it!
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};

export default MbiotaReminderModal;
